import { getLeadAttribution } from '../../src/lib/leadAttribution'

// This entry captures attribution without exposing or mounting the widget.
getLeadAttribution()
